import { render, staticRenderFns } from "./DsFooter.vue?vue&type=template&id=5ee4a54b&scoped=true"
import script from "./DsFooter.vue?vue&type=script&lang=js"
export * from "./DsFooter.vue?vue&type=script&lang=js"
import style0 from "./DsFooter.vue?vue&type=style&index=0&id=5ee4a54b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4a54b",
  null
  
)

export default component.exports